export default __webpack_public_path__ + "static/outside_carry_steps-e87080293145363cff89f008eebeace0.jpg";